import React from "react";
import { PriceDetailsPropTypes, PriceDetailsService } from "./types";

export default function usePriceDetailsService(props: PriceDetailsPropTypes): PriceDetailsService {
  // for get ticket on reg
  const { isFreeTicket, isDiscountedTicket } = React.useMemo(() => {
    return {
      isFreeTicket: !props.applicableRate || props.applicableRate?.applicablePrice?.value === 0,
      isDiscountedTicket: Boolean(
        props.applicableRate && props.applicableRate?.applicablePrice?.value < props.applicableRate?.basePrice?.value
      )
    };
  }, [props.applicableRate]);

  return { isFreeTicket, isDiscountedTicket };
}
